module.exports = __webpack_public_path__ + "static/img/dibu.c10371ee.png";